import { render, staticRenderFns } from "./ProjectListStatisticsTabs.vue?vue&type=template&id=03357b28&scoped=true&"
import script from "./ProjectListStatisticsTabs.vue?vue&type=script&lang=js&"
export * from "./ProjectListStatisticsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03357b28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VTab,VTabs,VTabsItems})
